var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-touch',{staticClass:"wrapper",on:{"swiperight":_vm.swiperright}},[_c('div',{staticClass:"informationPriceView"},[_c('HeaderNav',{attrs:{"header-title":"表单预览","left-icon-name":"2","right-icon-name":"5","extr":{ leftCallBack: _vm.swiperright }}}),_c('section',[_c('iframe',{attrs:{"src":_vm.formSrc,"frameborder":"0"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }